import { Injectable } from "@angular/core";
import { WebEquipment, EquipmentClient } from "../models";
import { Observable, BehaviorSubject } from "rxjs";
import { CustomerService } from "./customer.service";
import { LocationListService } from "./location-list.service";
import { EquipmentLocal } from "../models";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root"
})
export class EquipmentService
{

  private customerId: string;
  public equipmentSubject = new BehaviorSubject<EquipmentLocal[]>([]);
  public equipment: Observable<EquipmentLocal[]> = this.equipmentSubject.asObservable();

  private webEquipment: WebEquipment[] = [];

  constructor(
    private equipmentClient: EquipmentClient,
    private customerService: CustomerService,
    private locationListService: LocationListService,
    private authService: AuthService
  ) 
  {
    this.customerService.customerId.subscribe(customerId =>
    {
      this.customerId = customerId;
      if (this.authService.isLoggedIn())
      {
        this.getEquipmentList();
      }
    });

    this.locationListService.locationList.subscribe(l =>
    {
      this.populateEquipment();
    });
  }

  private getEquipmentList()
  {
    this.equipmentClient.getWebEquipmentByCustId(this.customerId)
      .subscribe(e =>
      {
        this.webEquipment = e;
        this.populateEquipment();
      });
  }

  private populateEquipment(): void
  {

    if (this.webEquipment?.length > 0)
    {
      const equipmentItems: EquipmentLocal[] = this.webEquipment.map(e =>
      {
        return { LocationUsageDesc: this.locationListService.getLocationDesc(e.Loc), ...e };
      });

      this.equipmentSubject.next(equipmentItems);
    }
  }
}
